import React from 'react'
import { intl } from 'lang/intl'

import Chyron, { ChyronSize } from './chyron'

import './question-chyron.scss'

interface QuestionChyronProps {
  question: string
  name: string
  title?: string
  avatarUrl?: string
}

const QuestionChyron = ({
  question,
  name,
  title,
  avatarUrl,
}: QuestionChyronProps) => {
  return (
    <Chyron
      size={ChyronSize.Dynamic}
      kicker={intl.formatMessage({ defaultMessage: 'Question' })}
    >
      <div className="question-chyron">
        <div className="question dynamic-section">{question}</div>
        <div className="profile-info">
          <div>
            {avatarUrl && <img className="picture" src={avatarUrl} alt="" />}
          </div>
          <div className="question-info">
            <span className="name">{name}</span>
            {title && <span className="title">{title}</span>}
          </div>
        </div>
      </div>
    </Chyron>
  )
}

export default QuestionChyron
